import React, { useState } from "react";
import ModalV2 from "../../../../../shared/components/modalV2";
import { Plus } from "lucide-react";

interface AttachFeeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddFee?: (data: any) => void;
}

const AttachFeeModal: React.FC<AttachFeeModalProps> = ({
  isOpen,
  onClose,
  onAddFee,
}) => {
  const [assessments, setAssessments] = useState([{ description: "", amount: "" }]);

  const handleAddAssessment = () => {
    setAssessments([...assessments, { description: "", amount: "" }]);
  };

  const handleAssessmentChange = (
    index: number,
    field: "description" | "amount",
    value: string,
  ) => {
    const updatedAssessments = [...assessments];
    updatedAssessments[index][field] = value;
    setAssessments(updatedAssessments);
  };

  return (
    <ModalV2
      isOpen={isOpen}
      isClose={onClose}
      maxWidth="w-[500px]"
      edges="rounded-2xl"
    >
      <div className="p-8 flex flex-col gap-y-6">
        <h2 className="text-xl font-bold text-center text-[#1A1A1A]">
          Attach fee
        </h2>

        <div className="flex flex-col gap-y-4">
          <input
            type="text"
            disabled
            value="Claimant letter B"
            className="w-full bg-gray-50 border border-[#E9EAEB] rounded-lg px-4 py-3 text-[#667085] text-sm"
          />

          {assessments.map((assessment, index) => (
            <div key={index} className="flex gap-x-3">
              <input
                type="text"
                placeholder="Enter assessment"
                value={assessment.description}
                onChange={(e) =>
                  handleAssessmentChange(index, "description", e.target.value)
                }
                className="flex-1 border border-[#E9EAEB] rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-[#00B074]"
              />
              <div className="w-[140px]">
                <input
                  type="text"
                  placeholder="NGN"
                  value={assessment.amount}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d*$/.test(val)) {
                      handleAssessmentChange(index, "amount", val);
                    }
                  }}
                  className="w-full border border-[#E9EAEB] rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-[#00B074]"
                />
              </div>
            </div>
          ))}
        </div>

        <button
          onClick={handleAddAssessment}
          className="flex items-center gap-x-2 text-[#1A1A1A] text-sm font-medium hover:text-[#00B074] w-fit"
        >
          <Plus className="w-4 h-4" />
          <span>Add other assessment</span>
        </button>

        <button
          onClick={() => {
            if (onAddFee) onAddFee(assessments);
            onClose();
          }}
          className="w-full bg-[#00B074] text-white rounded-lg py-3 font-medium hover:bg-[#009b65] transition-colors mt-2"
        >
          Add fee
        </button>
      </div>
    </ModalV2>
  );
};

export default AttachFeeModal;

